import React, { useEffect, useRef } from "react";

const PANNELLUM_CSS = "https://cdn.jsdelivr.net/npm/pannellum@2.5.6/build/pannellum.css";
const PANNELLUM_JS = "https://cdn.jsdelivr.net/npm/pannellum@2.5.6/build/pannellum.js";

const loadOnce = (() => {
  let promise = null;
  return () => {
    if (promise) return promise;
    promise = new Promise((resolve, reject) => {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = PANNELLUM_CSS;
      document.head.appendChild(link);
      const s = document.createElement("script");
      s.src = PANNELLUM_JS;
      s.async = true;
      s.onload = () => resolve();
      s.onerror = reject;
      document.body.appendChild(s);
    });
    return promise;
  };
})();

/**
 * 360° viewer for car interior. Accepts a panorama URL; falls back to a
 * placeholder card when none is supplied.
 */
const Panorama360 = ({ panoramaUrl, label = "Interior 360°" }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (!panoramaUrl || !ref.current) return undefined;
    let viewer;
    loadOnce()
      .then(() => {
        if (!ref.current || !window.pannellum) return;
        viewer = window.pannellum.viewer(ref.current, {
          type: "equirectangular",
          panorama: panoramaUrl,
          autoLoad: true,
          autoRotate: -2,
          showZoomCtrl: false,
          showFullscreenCtrl: true,
          compass: false,
          backgroundColor: [10, 10, 10],
        });
      })
      .catch(() => {});
    return () => {
      try {
        viewer && viewer.destroy();
      } catch {
        /* ignore */
      }
    };
  }, [panoramaUrl]);

  if (!panoramaUrl) {
    return (
      <div
        className="aspect-video bg-[#0d0d0d] border border-dashed border-white/20 flex flex-col items-center justify-center p-8 text-center"
        data-testid="panorama-placeholder"
      >
        <p className="text-label text-[#FFB400]">{label}</p>
        <p className="mt-3 font-heading text-xl text-white max-w-md">
          360° interior tour coming soon
        </p>
        <p className="mt-2 text-sm text-zinc-500 max-w-md">
          Send us a panoramic photo (equirectangular 2:1) and we'll plug it in.
        </p>
      </div>
    );
  }

  return (
    <div
      ref={ref}
      className="w-full aspect-video bg-black border border-white/10"
      data-testid="panorama-viewer"
    />
  );
};

export default Panorama360;
